import React from "react";
import { Icon, PlainButton } from "@culturehq/components";

import { Trans } from "app/utils";

import QuickOptions from "components/display/QuickOptions";
import Flag from "components/common/Flag";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

const CommentQuickLinks = ({ comment, canDelete, onDelete }) => (
  <QuickOptions>
    <ul className="dropdown-menu">
      {canDelete && (
        <li>
          <ChqModalConfirmDelete
            onAccept={() => onDelete(comment)}
            trigger={onTrigger => (
              <PlainButton onClick={onTrigger}>
                <Icon icon="ios-trash" />
                <Trans>Delete this comment.</Trans>
              </PlainButton>
            )}
          >
            <Trans>Are you sure you would like to delete this comment?</Trans>
          </ChqModalConfirmDelete>
        </li>
      )}
      <li>
        <Flag action="flagComment" options={{ commentId: comment.id }}>
          {onTrigger => (
            <PlainButton onClick={onTrigger}>
              <Icon icon="ios-flag" />
              <Trans>Flag this comment?</Trans>
            </PlainButton>
          )}
        </Flag>
      </li>
    </ul>
  </QuickOptions>
);

export default CommentQuickLinks;
